import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import '@angular/compiler';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-entity-action-map',
  standalone: true,
  imports: [CommonModule, FormsModule, HttpClientModule],
  template: `

<div class="min-h-screen bg-slate-50 p-4 font-sans text-slate-800">

  <div class="max-w-[1200px] mx-auto space-y-4">

    <!-- HEADER -->
    <div class="bg-white rounded-md shadow-sm border border-slate-200 p-4 flex items-center justify-between">
      <div>
        <h2 class="text-sm font-bold uppercase text-slate-800">
          Entity Action Mapping
        </h2>
        <p class="text-[10px] text-slate-500 uppercase">
          Workflow SP Mapping
        </p>
      </div>

      <button (click)="openModal()"
        class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-1.5 rounded text-xs font-bold shadow-sm flex items-center gap-1.5 uppercase">
        <span class="text-sm">+</span> New Mapping
      </button>
    </div>

    <!-- TABLE -->
    <div class="bg-white rounded-md shadow-sm border border-slate-200 overflow-hidden">

      <div class="overflow-x-auto">
        <table class="w-full text-left border-collapse">

          <thead>
            <tr class="bg-slate-50 border-b border-slate-200 text-[10px] uppercase text-slate-500 font-bold">
              <th class="px-6 py-3">Entity</th>
              <th class="px-6 py-3">Action</th>
              <th class="px-6 py-3">SP Name</th>
              <th class="px-6 py-3">Status</th>
              <th class="px-6 py-3 text-right">Actions</th>
            </tr>
          </thead>

          <tbody class="divide-y divide-slate-100">

            <tr *ngFor="let item of list"
                class="hover:bg-blue-50/30 transition-colors group">

              <!-- ENTITY -->
              <td class="px-6 py-3">
                <div class="text-xs font-bold text-slate-700 uppercase">
                  {{ item.entityCode }}
                </div>
              </td>

              <!-- ACTION -->
              <td class="px-6 py-3">
                <span class="text-[10px] font-bold text-blue-600 uppercase">
                  {{ item.actionCode }}
                </span>
              </td>

              <!-- SP -->
              <td class="px-6 py-3">
                <span class="font-mono text-[11px] text-slate-500 bg-slate-100 px-2 py-0.5 rounded border">
                  {{ item.spName }}
                </span>
              </td>

              <!-- STATUS -->
              <td class="px-6 py-3">
                <span
                  class="text-[9px] font-black px-2 py-0.5 rounded border uppercase"
                  [class]="item.isActive
                    ? 'bg-green-100 text-green-700 border-green-200'
                    : 'bg-slate-100 text-slate-400 border-slate-200'">
                  {{ item.isActive ? 'Active' : 'Inactive' }}
                </span>
              </td>

              <!-- ACTION BUTTONS -->
           
  <td class="px-6 py-3 text-right">
                                                <div class="flex justify-end gap-2 transition-opacity">

                                                      <button (click)="edit(item)"
                                                            class="p-1.5 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded transition-all">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"
                                                                        stroke-width="2" />
                                                            </svg>
                                                      </button>

                                                      <button (click)="delete(item)"
                                                            class="p-1.5 text-slate-400 hover:text-red-600 hover:bg-red-50 rounded transition-all">
                                                            <svg class="w-4 h-4" fill="none" stroke="currentColor"
                                                                  viewBox="0 0 24 24">
                                                                  <path d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"
                                                                        stroke-width="2" />
                                                            </svg>
                                                      </button>

                                                </div>
                                          </td>
            </tr>

            <tr *ngIf="!list.length">
              <td colspan="5" class="px-6 py-10 text-center text-slate-400 text-xs italic">
                No mapping records found
              </td>
            </tr>

          </tbody>
        </table>
      </div>
    </div>

  </div>

  <!-- MODAL -->
<div *ngIf="showModal"
     class="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/40 backdrop-blur-sm p-4">

  <div class="bg-white w-full max-w-lg rounded-lg shadow-2xl border border-slate-200 overflow-hidden">

    <!-- HEADER -->
    <div class="px-5 py-3 border-b border-slate-100 flex justify-between items-center bg-slate-50/80">
      <div>
        <h3 class="text-[11px] font-bold uppercase tracking-widest text-slate-700">
          {{ isEdit ? 'Update' : 'Create' }} Mapping
        </h3>
        <p class="text-[9px] text-slate-400 uppercase font-medium mt-0.5">
          Entity → Action → Stored Procedure
        </p>
      </div>

      <button (click)="closeModal()"
        class="text-slate-300 hover:text-red-500 text-xl leading-none">
        &times;
      </button>
    </div>

    <!-- BODY -->
    <div class="p-5 space-y-4">

      <!-- GRID -->
      <div class="grid grid-cols-2 gap-4">

        <!-- ENTITY -->
        <div>
          <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">
            Entity Code
          </label>
          <input
            [(ngModel)]="form.entityCode"
            placeholder="ex: customer"
            class="w-full px-2.5 py-1.5 border border-slate-200 rounded text-[11px]
                   focus:border-blue-500 focus:ring-1 focus:ring-blue-100 outline-none uppercase">
        </div>

        <!-- ACTION -->
        <div>
          <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">
            Action Code
          </label>

          <select
            [(ngModel)]="form.actionCode"
            class="w-full px-2.5 py-1.5 border border-slate-200 rounded text-[11px]
                   focus:border-blue-500 focus:ring-1 focus:ring-blue-100 outline-none uppercase bg-white">

            <option value="">Select Action</option>

            <option *ngFor="let a of actions" [value]="a">
              {{ a }}
            </option>

          </select>
        </div>

      </div>

      <!-- SP NAME -->
      <div>
        <label class="block text-[10px] font-bold text-slate-500 uppercase mb-1">
          Stored Procedure
        </label>

        <input
          [(ngModel)]="form.spName"
          placeholder="ex: usp_customer_approve"
          class="w-full px-2.5 py-1.5 border border-slate-200 rounded text-[11px] font-mono
                 focus:border-blue-500 focus:ring-1 focus:ring-blue-100 outline-none">
      </div>

      <!-- ACTIVE -->
      <div class="flex items-center gap-2 p-2 bg-slate-50 border border-slate-100 rounded">
        <input
          type="checkbox"
          [(ngModel)]="form.isActive"
          class="w-3.5 h-3.5 text-blue-600 border-slate-300 rounded cursor-pointer">

        <label class="text-[10px] font-bold text-slate-600 uppercase cursor-pointer">
          Active Mapping
        </label>
      </div>

    </div>

    <!-- FOOTER -->
    <div class="px-5 py-3 border-t border-slate-100 flex justify-end gap-3">

      <button (click)="closeModal()"
        class="text-[10px] font-bold text-slate-400 uppercase hover:text-slate-600">
        Cancel
      </button>

      <button (click)="save()"
        class="bg-blue-600 text-white px-6 py-1.5 rounded text-[10px] font-bold uppercase
               hover:bg-blue-700 shadow-sm transition-all">
        {{ isEdit ? 'Update' : 'Save' }}
      </button>

    </div>

  </div>
</div>

</div>
`
})
export class EntityActionMapComponent implements OnInit {

  api = `${environment.apiUrl}/api/sys/entity-action-map`;

  list: any[] = [];
  actions: string[] = [];

  showModal = false;
  isEdit = false;

  oldEntityCode = '';
  oldActionCode = '';

  form: any = {
    entityCode: '',
    actionCode: '',
    spName: '',
    isActive: true
  };

  constructor(private http: HttpClient) { }

  ngOnInit() {
    this.load();
    this.loadActions();
  }

  load() {
    this.http.get<any[]>(this.api).subscribe(res => this.list = res);
  }

  loadActions() {
    this.http.get<string[]>(this.api + '/actions')
      .subscribe(res => this.actions = res);
  }

  openModal() {
    this.isEdit = false;
    this.form = { entityCode: '', actionCode: '', spName: '', isActive: true };
    this.showModal = true;
  }

  edit(item: any) {
    this.isEdit = true;
    this.form = { ...item };
    this.oldEntityCode = item.entityCode;
    this.oldActionCode = item.actionCode;
    this.showModal = true;
  }

  save() {

    if (!this.form.entityCode || !this.form.actionCode) {
      alert('Entity & Action required');
      return;
    }

    // normalize
    this.form.entityCode = this.form.entityCode.toLowerCase();
    this.form.actionCode = this.form.actionCode.toUpperCase();

    if (this.isEdit) {

      const payload = {
        ...this.form,
        oldEntityCode: this.oldEntityCode,
        oldActionCode: this.oldActionCode
      };

      this.http.put(this.api, payload).subscribe({
        next: () => {
          this.load();
          this.closeModal();
        },
        error: err => alert(err?.error || 'Duplicate not allowed')
      });

    } else {

      this.http.post(this.api, this.form).subscribe({
        next: () => {
          this.load();
          this.closeModal();
        },
        error: err => alert(err?.error || 'Duplicate not allowed')
      });

    }
  }

  delete(item: any) {
    if (!confirm('Delete?')) return;

    this.http.delete(`${this.api}/${item.entityCode}/${item.actionCode}`)
      .subscribe(() => this.load());
  }

  closeModal() {
    this.showModal = false;
  }
}